import store from "@/store";
import {CURRENT_UI_LANGUAGE} from "@/store/getter-types";

export function getLocale (): string {
  return store.getters[CURRENT_UI_LANGUAGE].code
}
